import { LocaleService } from '../services/locale.service';

export class GenericField {
	protected key: string;
	protected type: string;
	protected valueString: string;

	getKey(){
		return this.key;
	}

	getType(){
		return this.type;
	}

	getValue(){
	}

	getValueString(){
		return this.valueString;
	}

	setValue(value: any){
	}

    clear(){
	}

	toString(formatter: LocaleService){
	}
}

